import { useContext } from "react"

import Spacer from "@p-ban/common/src/components/layout/Spacer"
import SEMINAR_CATEGORY from "@p-ban/core/src/seminar/constant/SEMINAR_CATEGORY"

import LinkLikeButton from "../../../components/mypage/Button/LinkLikeButton"
import MyPageButtonContainer from "../../../components/mypage/layout/MyPageButtonContainer"
import Text from "../../../components/ui/Text/Text"
import MyPageLayout from "../../../layout/MyPage/MyPageLayout"
import SeminarTemplate from "../components/SeminarTemplate"
import { SeminarEntryFormContext } from "../context/SeminarEntryFormContext"

const SeminarEntryComplete = () => {
  const { seminar, isLoggedIn } = useContext(SeminarEntryFormContext)

  const getSeminarTopUrl = () => {
    switch (seminar.seminarCategory) {
      case SEMINAR_CATEGORY.CadlusXFreeTrialSeminar.value:
        return "/cadlus/seminar.html"
      case SEMINAR_CATEGORY.DesignSparkPcbTrainingSeminar.value:
        return "/dspcb/seminar.html"
      case SEMINAR_CATEGORY.QuadceptTrainingSeminar.value:
        return "/quadcept/quadcept_seminar.html"
      case SEMINAR_CATEGORY.TechnicalSeminar.value:
        return "/seminar/schedule.html"
      default:
        return "/others/seminar_beginner.html"
    }
  }

  return (
    <MyPageLayout layout={isLoggedIn ? "full" : "simple"}>
      <SeminarTemplate>
        <Spacer size={2} />
        <h3>お申込みを受け付けました。</h3>
        <Text>
          お申込み内容につきましては、確認メールをお送りしておりますので、ご確認ください。
          <br />
          数分しても確認メールが届かない場合は、お手数ですが<a href="mailto:info@p-ban.com">info@p-ban.com</a>
          までお問い合わせ下さい。
        </Text>
        <Spacer size={40} />
        <MyPageButtonContainer>
          <LinkLikeButton href={getSeminarTopUrl()}>P板.comセミナーページへ戻る</LinkLikeButton>
          <LinkLikeButton href="/">トップページへ移動</LinkLikeButton>
        </MyPageButtonContainer>
      </SeminarTemplate>
    </MyPageLayout>
  )
}

export default SeminarEntryComplete
